export default __webpack_public_path__ + "static/media/coinbase_logo.48486003.svg";